<template>
  <main class="share-landing">
    <div class="share-page">
      <header class="brand-bar">
        <div class="brand">WINNER<span>体育</span></div>
        <span v-if="!error" class="share-chip">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7"/><path d="M16 6l-4-4-4 4"/><path d="M12 2v13"/></svg>好友分享
        </span>
      </header>

      <template v-if="error">
        <div class="error-body">
          <div class="error-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c9a6ee" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.5 14.5l-1.8 1.8a3.2 3.2 0 0 1-4.5-4.5l2.8-2.8a3.2 3.2 0 0 1 4.5 0"/><path d="M14.5 9.5l1.8-1.8a3.2 3.2 0 0 1 4.5 4.5l-2.8 2.8a3.2 3.2 0 0 1-4.5 0"/><path d="M9 4.5l.8 2"/><path d="M4.5 9l2 .8"/><path d="M15 19.5l-.8-2"/><path d="M19.5 15l-2-.8"/></svg>
          </div>
          <h1 class="error-title">{{ errorTitle }}</h1>
          <p class="error-text" role="alert">{{ error }}</p>
        </div>
        <section class="sheet">
          <button v-if="loginRequired" class="btn btn-primary" @click="loginForShare">登录后查看</button>
          <button v-else class="btn btn-primary" @click="load">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg>重新加载
          </button>
          <p v-if="!loginRequired" class="footnote">网络不稳定时，重新加载通常就能恢复</p>
        </section>
      </template>

      <template v-else>
        <div class="intro">
          <p class="eyebrow">你的好友邀请你进入直播间</p>
          <h1 class="headline">好比赛，一起看</h1>
        </div>

        <template v-if="busy">
          <div class="cover skel"></div>
          <div class="host">
            <div class="avatar skel"></div>
            <div class="host-text"><div class="skel skel-line" style="width:96px;height:14px"></div><div class="skel skel-line" style="width:140px;height:10px;margin-top:8px"></div></div>
          </div>
          <div class="skel skel-line" style="width:80%;height:16px;margin:16px 20px 0"></div>
        </template>
        <template v-else>
          <div class="cover" :class="{ 'is-ended': ended }">
            <svg class="pitch" viewBox="0 0 350 197" fill="none" preserveAspectRatio="none" aria-hidden="true">
              <rect v-for="x in [0, 70, 140, 210, 280]" :key="x" :x="x" y="0" width="35" height="197" fill="#ffffff" fill-opacity="0.03"/>
              <g :stroke="ended ? '#9c8fb0' : '#c9a6ee'" stroke-opacity="0.3" stroke-width="1.5">
                <rect x="14" y="14" width="322" height="169" rx="2"/><path d="M175 14v169"/><circle cx="175" cy="98.5" r="28"/>
                <rect x="14" y="56" width="50" height="85"/><rect x="286" y="56" width="50" height="85"/>
                <rect x="14" y="80" width="18" height="37"/><rect x="318" y="80" width="18" height="37"/>
              </g>
            </svg>
            <img v-if="coverUrl" class="cover-img" :src="coverUrl" alt="" @error="coverFailed = true">
            <span v-if="badge" class="badge" :class="{ 'badge-live': live }"><i v-if="live" class="badge-dot"></i>{{ badge }}</span>
            <div class="cover-center">
              <template v-if="ended">
                <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#d3c6e2" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
                <span class="cover-caption strong">本场直播已结束</span>
              </template>
              <template v-else>
                <span class="play"><svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="#ffffff"/></svg></span>
                <span v-if="!room" class="cover-caption">WINNER 体育 · 直播间</span>
              </template>
            </div>
          </div>
          <template v-if="room">
            <div class="host">
              <div class="avatar" :class="{ 'is-ended': ended }">
                <img v-if="avatarUrl" :src="avatarUrl" alt="" @error="avatarFailed = true">
                <span v-else>{{ avatarInitial }}</span>
              </div>
              <div class="host-text">
                <div class="host-name">{{ room.nickname || '主播' }}</div>
                <div class="host-meta">{{ hostMeta }}</div>
              </div>
            </div>
            <p v-if="room.title" class="room-title" :class="{ 'is-ended': ended }">{{ room.title }}</p>
          </template>
        </template>

        <section class="sheet">
          <template v-if="busy">
            <p class="loading" role="status">
              <svg class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>正在打开直播间…
            </p>
            <div class="btn-skel skel-light"></div>
            <div class="btn-skel skel-light short"></div>
          </template>
          <template v-else-if="isAndroid">
            <div v-if="phase === 'fallback'" class="notice" role="status">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a15c00" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><path d="M12 16.5v.01"/></svg>
              <div>
                <div class="notice-title">没有自动打开 APP？</div>
                <div class="notice-text">可能还没安装，或浏览器拦截了跳转。可以再试一次，或直接网页观看。</div>
              </div>
            </div>
            <button class="btn btn-primary" :disabled="phase === 'opening'" @click="openApp">
              <template v-if="phase === 'opening'"><svg class="spin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>正在打开 APP…</template>
              <template v-else-if="phase === 'fallback'"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg>再试一次</template>
              <template v-else><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="2" width="12" height="20" rx="3"/><path d="M11 9.5v5l4-2.5z" fill="currentColor"/></svg>{{ ended ? '打开 APP 看更多直播' : '打开 APP 观看' }}</template>
            </button>
            <button class="btn btn-secondary" :disabled="navigating" @click="openWeb">
              <template v-if="navigating"><svg class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>正在进入直播间…</template>
              <template v-else><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18z"/></svg>{{ ended ? '网页进入直播间' : '网页直接观看' }}</template>
            </button>
            <div class="download-row">
              <span>还没安装 APP？</span>
              <button class="link-btn" @click="download">下载安装<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4v11"/><path d="M7 10l5 5 5-5"/><path d="M5 20h14"/></svg></button>
            </div>
            <p v-if="phase !== 'fallback'" class="footnote">{{ ended ? '主播下次开播时，可在 APP 直播列表里找到' : '安装完成后回到本页，点「打开 APP 观看」直达该直播间' }}</p>
          </template>
          <template v-else>
            <button class="btn btn-primary" :disabled="navigating" @click="openWeb">
              <template v-if="navigating"><svg class="spin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M12 3a9 9 0 1 0 9 9"/></svg>正在进入直播间…</template>
              <template v-else><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18z"/></svg>{{ ended ? '网页进入直播间' : '进入直播间观看' }}</template>
            </button>
          </template>
        </section>
      </template>
    </div>

    <transition name="rise"><div v-if="hint" class="toast" role="status"><span>{{ hint }}</span></div></transition>

    <transition name="rise">
      <div v-if="guide" class="guide" role="dialog" aria-modal="true" aria-label="在浏览器中打开">
        <svg class="guide-arrow" width="132" height="110" viewBox="0 0 132 110" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 104C54 100 104 78 116 18" stroke-dasharray="2 8"/><path d="M103 27l13-14 12 16"/></svg>
        <h2 class="guide-title">{{ guideTitle }}</h2>
        <p class="guide-text">换到手机浏览器，就能一键进入这个直播间</p>
        <ol class="guide-steps">
          <li><span class="step">1</span>点击右上角<span class="dots"><i></i><i></i><i></i></span></li>
          <li><span class="step">2</span>选择「在浏览器打开」</li>
          <li><span class="step">3</span>在浏览器里点「打开 APP 观看」</li>
        </ol>
        <div class="guide-actions">
          <button class="btn btn-light" @click="guide = false; openWeb()">不切换，直接网页观看</button>
          <button class="btn btn-ghost" @click="guide = false">我知道了</button>
        </div>
      </div>
    </transition>
  </main>
</template>
<script>
import { requestId, deviceType, saveShareVisit } from '../utils/liveShare';
const INVALID_LINK = '分享链接无效，请联系分享人重新分享。';
const SERVICE_DOWN = '直播分享服务暂时不可用，请稍后重试。';
// 分享码跟随主播：离开页面超过该时长再回来就重新解析，按主播当前的直播间打开。
const STALE_MS = 5 * 60 * 1000;
// 这些错误说明链接本身不可用，其余（网络、服务）归为暂时性问题。
const LINK_ERRORS = [INVALID_LINK, '分享链接无效', '分享链接不存在', '该直播间已停用'];
// 页面可展示的错误；axios 原始英文 message 不直接给用户看。
function shareError(message) { const error = new Error(message); error.shareMessage = message; return error; }
function friendlyError(e) {
  if (e && e.shareMessage) return e.shareMessage;
  if (e && e.response) return SERVICE_DOWN;
  if (e && (e.code === 'ECONNABORTED' || /timeout/i.test(e.message || ''))) return '网络连接超时，请检查网络后重试。';
  if (e && e.request) return '网络异常，请检查网络后重试。';
  return SERVICE_DOWN;
}
// 后台时间 Y-m-d H:i:s：当天只显示时分，其他日期带月日；零值或非法返回空。
function timeLabel(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})/.exec(typeof value === 'string' ? value : '');
  if (!m || m[1] === '0000') return '';
  const now = new Date();
  const today = +m[1] === now.getFullYear() && +m[2] === now.getMonth() + 1 && +m[3] === now.getDate();
  return (today ? '' : (+m[2]) + '月' + (+m[3]) + '日 ') + m[4] + ':' + m[5];
}
export default {
  name: 'LiveShare',
  data() {
    return { busy: true, error: '', loginRequired: false, hint: '', device: deviceType(), liveId: 0, source: '', visit: null, requestKey: requestId(), resolvedAt: 0, downloadUrl: '', timer: null, hintTimer: null, generation: 0, navigating: false,
      room: null, coverFailed: false, avatarFailed: false, phase: '', guide: false, embedded: /MicroMessenger|QQ\//i.test(navigator.userAgent) };
  },
  computed: {
    isAndroid() { return this.device === 'android'; },
    status() { return this.room ? Number(this.room.status) : -1; },
    live() { return this.status === 1; },
    ended() { return this.status === 2; },
    badge() { return this.live ? '直播中' : this.ended ? '已结束' : this.status === 0 ? '未开播' : ''; },
    coverUrl() { return this.room && !this.coverFailed && typeof this.room.thumb_full === 'string' ? this.room.thumb_full : ''; },
    avatarUrl() { return this.room && !this.avatarFailed && typeof this.room.host_avatar_full === 'string' ? this.room.host_avatar_full : ''; },
    avatarInitial() { return Array.from(String(this.room && this.room.nickname || '主'))[0]; },
    hostMeta() {
      if (this.live) { const t = timeLabel(this.room.started_at); return '主播 · ' + (t ? t + ' 开播' : '正在直播'); }
      if (this.ended) return '主播 · 已下播';
      const t = timeLabel(this.room.live_time);
      return '主播 · ' + (t ? '预计 ' + t + ' 开播' : '尚未开播');
    },
    errorTitle() { return this.loginRequired ? '登录后查看直播间' : LINK_ERRORS.indexOf(this.error) >= 0 ? '这个链接打不开了' : '暂时无法打开直播间'; },
    guideTitle() { return /QQ\//i.test(navigator.userAgent) && !/MicroMessenger/i.test(navigator.userAgent) ? 'QQ 里无法直接打开 APP' : '微信里无法直接打开 APP'; }
  },
  watch: {
    // 同一页面切换到另一个分享链接时重新解析，不沿用旧房间和旧归因。
    '$route.query'(to, from) {
      if (this.$route.path !== '/live_share' || (to.s === from.s && to.id === from.id)) return;
      if (to.s !== from.s) this.requestKey = requestId();
      this.navigating = false; this.load();
    }
  },
  mounted() { document.addEventListener('visibilitychange', this.visibility); this.load(); },
  beforeDestroy() { ++this.generation; clearTimeout(this.timer); clearTimeout(this.hintTimer); document.removeEventListener('visibilitychange', this.visibility); },
  methods: {
    // 页面被切到后台说明已唤起 APP：取消兜底提示，回来时按钮恢复可点。
    // 停留过久再回来（如安装 APP 后、隔天切回标签页）重新解析，不用旧房间打开 APP 或网页。
    visibility() {
      if (document.hidden) { clearTimeout(this.timer); if (this.phase === 'opening') this.phase = ''; return; }
      if (!this.source || this.busy || this.navigating || !this.resolvedAt || Date.now() - this.resolvedAt < STALE_MS) return;
      if (this.visit && this.visit.expires_at * 1000 <= Date.now()) this.requestKey = requestId();
      return this.load();
    },
    showHint(text) {
      clearTimeout(this.hintTimer); this.hint = text;
      this.hintTimer = setTimeout(() => { this.hint = ''; }, 3000);
    },
    loginForShare() {
      try { sessionStorage.setItem('yn_login_redirect', this.$route.fullPath); } catch (e) { this.showHint('请登录后返回此分享链接。'); }
      this.$router.push('/login').catch(() => {});
    },
    async load() {
      const generation = ++this.generation; this.busy = true; this.error = ''; this.loginRequired = false; this.hint = ''; this.visit = null; this.liveId = 0; clearTimeout(this.timer);
      this.room = null; this.coverFailed = false; this.avatarFailed = false; this.phase = ''; this.guide = false;
      try {
        const query = this.$route.query;
        const shared = Object.prototype.hasOwnProperty.call(query, 's');
        this.source = shared && typeof query.s === 'string' ? query.s : '';
        if (shared) {
          // 链接带了分享参数但为空、数组或格式错误时本地拒绝，不退回 id 直达。
          if (!/^[a-f0-9]{32}$/.test(this.source)) throw shareError(INVALID_LINK);
          // 后台 var_pathinfo=s，HTTP GET 参数 s 会被框架当作路由，分享码必须用 share_code 传递。
          const resolved = await this.$axios.get('/api/live/share/resolve', { params: { share_code: this.source }, timeout: 10000 });
          if (generation !== this.generation) return;
          // HTTP 200 但返回 HTML 等非约定结构，不当作解析成功。
          if (!resolved || typeof resolved !== 'object') throw shareError(SERVICE_DOWN);
          if (resolved.code !== 200) {
            if (resolved.data && resolved.data.login_required === 1) { this.loginRequired = true; throw shareError('请登录后查看'); }
            throw shareError(typeof resolved.msg === 'string' && resolved.msg ? resolved.msg : SERVICE_DOWN);
          }
          const liveId = resolved.data && typeof resolved.data === 'object' ? Number(resolved.data.live_id) : NaN;
          if (!Number.isSafeInteger(liveId) || liveId <= 0) throw shareError(SERVICE_DOWN);
          this.liveId = liveId;
          // 房间摘要是可选展示信息，旧后台没有该字段时退回品牌占位。
          const room = resolved.data.room;
          this.room = room && typeof room === 'object' ? room : null;
          try {
            const visit = await this.$axios.post('/api/live/share/visit', { s: this.source, request_id: this.requestKey, device: this.device }, { timeout: 4000 });
            if (generation !== this.generation) return;
            if (visit.code === 200) this.visit = visit.data;
          } catch (e) { /* 统计失败不阻塞已经解析成功的房间 */ }
        } else this.liveId = Number(this.$route.query.id);
        if (!Number.isSafeInteger(this.liveId) || this.liveId <= 0) throw shareError(INVALID_LINK);
        if (generation !== this.generation) return;
        this.busy = false; this.resolvedAt = Date.now();
        // iOS 与已结束直播直接进网页直播间，已结束时由直播间展示结束页。
        if (this.device === 'ios' || this.ended) this.openWeb();
        else if (this.device === 'android') {
          this.$axios.get('/api/app/check/update', { timeout: 5000 }).then(res => {
            if (generation !== this.generation) return;
            const url = res.code === 200 && res.data && res.data.download_url;
            if (typeof url === 'string' && /^https?:\/\//i.test(url)) this.downloadUrl = url;
          }).catch(() => {});
        }
      } catch (e) { if (generation === this.generation) { this.error = friendlyError(e); this.busy = false; } }
    },
    openWeb() {
      if (this.navigating) return;
      this.navigating = true;
      const query = { id: String(this.liveId) };
      if (this.visit) {
        const key = saveShareVisit(this.requestKey, Object.assign({ live_id: this.liveId }, this.visit));
        if (key) query.sv = key;
      }
      this.$router.replace({ path: '/live_room', query }).catch(error => {
        this.navigating = false;
        if (!error || error.name !== 'NavigationDuplicated') this.showHint('页面打开失败，请重试。');
      });
    },
    openApp() {
      // 微信/QQ 内置浏览器拦截自定义协议，直接引导去系统浏览器。
      if (this.embedded) { this.guide = true; return; }
      let url = 'ikaros://pages/index/navto/liveDetail?id=' + this.liveId;
      if (this.visit) url += '&s=' + this.source + '&visit_token=' + encodeURIComponent(this.visit.visit_token) + '&expires_at=' + this.visit.expires_at;
      clearTimeout(this.timer);
      this.phase = 'opening';
      this.timer = setTimeout(() => { this.phase = document.hidden ? '' : 'fallback'; }, 1800);
      window.location.href = url;
    },
    download() {
      if (!this.downloadUrl) { this.showHint('下载暂不可用，请稍后重试；可以先选择网页观看。'); return; }
      window.location.href = this.downloadUrl;
    }
  }
};
</script>
<style scoped>
.share-landing{min-height:100vh;background:#140d1c;color:#fff;font-family:"PingFang SC","Noto Sans SC","Microsoft YaHei",system-ui,sans-serif;text-align:left}
.share-page{box-sizing:border-box;display:flex;flex-direction:column;max-width:480px;min-height:100vh;margin:0 auto}
.brand-bar{display:flex;align-items:center;justify-content:space-between;padding:20px 20px 0}
.brand{font-family:"DIN Alternate","Barlow Condensed","DIN Condensed",sans-serif;font-size:26px;font-weight:800;letter-spacing:3px;line-height:1}
.brand span{margin-left:8px;font-family:"PingFang SC","Noto Sans SC",sans-serif;font-size:14px;font-weight:700;letter-spacing:2px;color:#c9a6ee}
.share-chip{display:flex;align-items:center;height:28px;padding:0 12px;border-radius:14px;background:#2a1d38;color:#e2d3f3;font-size:12px}
.share-chip svg{margin-right:6px}
.intro{padding:26px 20px 0}
.eyebrow{margin:0;font-size:13px;letter-spacing:1px;color:#b9a3d2}
.headline{margin:8px 0 0;font-size:34px;line-height:1.2;font-weight:900;letter-spacing:1px}
.cover{position:relative;height:0;padding-top:56.25%;margin:22px 20px 0;border-radius:18px;overflow:hidden;background:#2b1d3c}
.cover.is-ended{background:#221a2c}
.pitch,.cover-img{position:absolute;left:0;top:0;width:100%;height:100%}
.cover-img{object-fit:cover}
.cover.is-ended .cover-img{filter:grayscale(1) brightness(.45)}
.badge{position:absolute;top:12px;left:12px;display:flex;align-items:center;height:24px;padding:0 10px;border-radius:12px;background:#4a3f57;font-size:12px;font-weight:700}
.badge-live{background:#d4313c}
.badge-dot{width:6px;height:6px;margin-right:6px;border-radius:3px;background:#fff;animation:pulse 1.6s ease-out infinite}
.cover-center{position:absolute;left:0;top:0;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}
.play{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:60px;height:60px;border-radius:30px;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.4)}
.cover-caption{margin-top:12px;font-size:13px;letter-spacing:2px;color:#d9c6ee}
.cover-caption.strong{margin-top:10px;font-size:15px;font-weight:600;letter-spacing:0;color:#e6dcf1}
.host{display:flex;align-items:center;margin:16px 20px 0}
.avatar{flex-shrink:0;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:40px;height:40px;margin-right:12px;border-radius:20px;border:2px solid #c9a6ee;background:#5b3782;overflow:hidden;font-size:16px;font-weight:700}
.avatar.skel{border:0}
.avatar.is-ended{border-color:#6d5f7e;background:#3f3050}
.avatar img{width:100%;height:100%;object-fit:cover}
.host-text{flex:1;min-width:0}
.host-name{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:15px;font-weight:600}
.host-meta{margin-top:2px;font-size:12px;color:#a996bf}
.room-title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin:12px 20px 0;font-size:16px;line-height:1.5;font-weight:600;color:#eee4f8;word-break:break-all}
.room-title.is-ended{color:#cbbfd8}
.sheet{margin-top:auto;padding:24px 20px 28px;padding-bottom:calc(28px + env(safe-area-inset-bottom));border-radius:28px 28px 0 0;background:#fff;color:#1f1628}
.sheet>*+*{margin-top:12px}
.btn{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:100%;border:0;border-radius:16px;font-family:inherit;cursor:pointer;-webkit-appearance:none;-webkit-tap-highlight-color:transparent;transition:transform .12s ease}
.btn:active{transform:scale(.985)}
.btn:disabled{cursor:default;opacity:.92}
.btn svg{margin-right:10px;flex-shrink:0}
.btn-primary{height:56px;background:#7447a0;color:#fff;font-size:17px;font-weight:700;letter-spacing:1px;box-shadow:0 10px 24px rgba(116,71,160,.3)}
.btn-secondary{height:52px;border:1.5px solid #ddcdef;background:#f6f0fc;color:#5b3782;font-size:16px;font-weight:600}
.btn-secondary svg{margin-right:8px}
.download-row{display:flex;align-items:center;justify-content:center;font-size:14px;color:#6f6680}
.sheet>.download-row{margin-top:14px}
.link-btn{display:flex;align-items:center;height:44px;padding:0 6px;border:0;background:none;color:#6a3f96;font-family:inherit;font-size:14px;font-weight:700;cursor:pointer}
.link-btn svg{margin-left:4px}
.footnote{margin:0;font-size:12px;line-height:1.7;text-align:center;color:#6f6680}
.loading{display:flex;align-items:center;justify-content:center;height:24px;margin:0;font-size:14px;color:#5b3782}
.loading svg{margin-right:8px}
.btn-skel{height:56px;border-radius:16px}
.btn-skel.short{height:52px}
.notice{display:flex;padding:14px;border-radius:14px;background:#fbf5ec;border:1px solid #efdcbf;animation:rise .28s ease-out both}
.notice svg{flex-shrink:0;margin:1px 12px 0 0}
.notice-title{font-size:14px;font-weight:700;color:#3d2a12}
.notice-text{margin-top:2px;font-size:12px;line-height:1.6;color:#6b5234}
.error-body{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 32px;text-align:center}
.error-icon{display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:96px;height:96px;border-radius:48px;background:#221830;border:1px solid #3a2a4d}
.error-title{margin:28px 0 0;font-size:26px;line-height:1.3;font-weight:900}
.error-text{margin:12px 0 0;font-size:15px;line-height:1.7;color:#b9a3d2}
.skel{background:linear-gradient(90deg,#241a31 0%,#352650 50%,#241a31 100%);background-size:200% 100%;animation:shimmer 1.4s linear infinite}
.skel-line{border-radius:8px}
.skel-light{background:linear-gradient(90deg,#f1ebf7 0%,#faf7fd 50%,#f1ebf7 100%);background-size:200% 100%;animation:shimmer 1.4s linear infinite}
.spin{animation:spin .8s linear infinite}
.toast{position:fixed;z-index:20;top:16px;left:20px;right:20px;display:flex;justify-content:center;pointer-events:none}
.toast span{padding:10px 16px;border-radius:20px;background:#fff;color:#1f1628;font-size:13px;line-height:1.5;box-shadow:0 8px 24px rgba(0,0,0,.3)}
.guide{position:fixed;z-index:30;left:0;top:0;right:0;bottom:0;display:flex;flex-direction:column;box-sizing:border-box;padding:8px 20px 32px;padding-bottom:calc(32px + env(safe-area-inset-bottom));background:rgba(12,7,18,.92);color:#fff}
.guide-arrow{align-self:flex-end;margin-right:-6px}
.guide-title{margin:12px 0 0;font-size:24px;line-height:1.35;font-weight:800}
.guide-text{margin:8px 0 0;font-size:14px;line-height:1.7;color:#cdbde0}
.guide-steps{margin:28px 0 0;padding:0;list-style:none}
.guide-steps li{display:flex;align-items:center;font-size:16px}
.guide-steps li+li{margin-top:18px}
.step{flex-shrink:0;display:flex;align-items:center;justify-content:center;width:28px;height:28px;margin-right:14px;border-radius:14px;background:#7447a0;font-family:"DIN Alternate","Barlow Condensed",sans-serif;font-size:17px;font-weight:700}
.dots{display:inline-flex;align-items:center;justify-content:center;width:38px;height:24px;margin-left:8px;border-radius:12px;background:rgba(255,255,255,.2)}
.dots i{width:4px;height:4px;margin:0 1.5px;border-radius:2px;background:#fff}
.guide-actions{margin-top:auto}
.guide-actions .btn+.btn{margin-top:12px}
.btn-light{height:52px;background:#fff;color:#5b3782;font-size:16px;font-weight:700}
.btn-ghost{height:48px;border:1.5px solid rgba(255,255,255,.35);background:transparent;color:#fff;font-size:15px}
.btn:focus-visible,.link-btn:focus-visible{outline:3px solid #c9a6ee;outline-offset:2px}
.rise-enter-active,.rise-leave-active{transition:opacity .25s ease,transform .25s ease}
.rise-enter,.rise-leave-to{opacity:0;transform:translateY(8px)}
@keyframes spin{to{transform:rotate(360deg)}}
@keyframes shimmer{from{background-position:200% 0}to{background-position:-200% 0}}
@keyframes pulse{0%{box-shadow:0 0 0 0 rgba(255,255,255,.75)}80%,100%{box-shadow:0 0 0 7px rgba(255,255,255,0)}}
@keyframes rise{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
</style>
